import React, { memo, useCallback } from 'react';
import styled, { css } from 'styled-components';

import { smallMediaQuery } from '../../../common/utilities/sizeHelpers';

interface AqiHealthAdviceTopTriggerModalBodyProps {
    healthAdviceDetails?: string;
    pollutantDetailsList?: string[];
    isLoadingDetails?: boolean; 
    detailsLoadError?: boolean; 
}

export const AqiHealthAdviceTopTriggerModalBody = memo(({ 
    isLoadingDetails,
    detailsLoadError,
    pollutantDetailsList,
    healthAdviceDetails  }: AqiHealthAdviceTopTriggerModalBodyProps) => {

    const renderModalBodyView = useCallback((isLoading?: boolean, loadError?: boolean, pollutantDetailList?: string[], healthAdvice?: string) => {
        // TODO: use implemented loading UI after product handoff
        if (isLoading) {
            return null;
        }

        // TODO: use implemented details error UI after product handoff
        if (loadError) {
            return null;
        }

        if (healthAdvice) {
            return <HealthAdviceDetail>{healthAdvice}</HealthAdviceDetail>;
        }

        if (pollutantDetailList?.length) {
            return (
                <PollutantsDetailsList>
                    {pollutantDetailList.map((pollutantDetail: string, index: number) => {
                        return <PollutantDetailItem key={index}>{pollutantDetail}</PollutantDetailItem>;
                    })}
                </PollutantsDetailsList>
            );
        }

        return null; // we should should never really get here for any of the modals

    }, []);

    return (
        <Container>
            {renderModalBodyView(isLoadingDetails, detailsLoadError, pollutantDetailsList, healthAdviceDetails)}
        </Container>
    );
});

AqiHealthAdviceTopTriggerModalBody.displayName = 'AqiHealthAdviceTopTriggerModalBody';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px;
    background-color: #F9F9F9;
    color: #555555;
    font-family: Source Sans Pro;
    font-size: 14px;
    font-weight: 400;
    white-space: pre-wrap;
    width: 470px;

    @media ${smallMediaQuery} {
        width: 97%;
    }
`;

const PollutantsDetailsList = styled.ul`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    list-style-type: disc;
    padding: 0px 13px;
    min-height: 609px;
    @media ${smallMediaQuery} {
        min-height: 379px;
    }
`;

const CommonStyleDetailView = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: #555555;
`;

const PollutantDetailItem = styled.li`
    ${CommonStyleDetailView}
    display: list-item;
    min-height: 23px;
    margin-bottom: 5px;
    height: auto;
`;

const HealthAdviceDetail = styled.p`
    ${CommonStyleDetailView}
    justify-content: flex-start;
    align-items: flex-start;
    min-height: 609px;
    @media ${smallMediaQuery} {
        min-height: 379px;
    }
`;
